import BottomSheet from '../BottomSheet'
import PlayerInfo from '../PlayerInfo'
import Style from './style'
import ActionButton from './ui/ActionButton'
import TournamentSection from './ui/TournamentSection'

const TournamentBottomSheet = ({
	isOpen,
	onClose,
	scanData = null,
	handleRefetch,
	isLoading,
	clearAndRescan,
}) => {
	const handleClose = () => {
		onClose()
	}
	// Extract data from API response
	const userInfo = scanData?.user_info || {}

	// Map pro_grade_flag to qualification text
	const getQualification = (userInfo) => {
		return `${userInfo.franchise_name || 'ADMIN'} - ${userInfo.qualification_name}`
	}

	const eventData = scanData?.eligible_competitions[0] || {}

	const {max_reentry, count} = eventData?.participation_history || {}
	const {can_eliminate, can_addon, can_reenter, required_tickets} =
		eventData || {}

	return (
		<BottomSheet
			isOpen={isOpen}
			onClose={handleClose}
			title='플레이어 정보'
			showCloseButton={true}
			footer={
				<ActionButton
					data={eventData}
					can_reenter={can_reenter}
					can_eliminate={can_eliminate}
					can_addon={can_addon}
					count={count}
					max_reentry={max_reentry}
					user_idx={userInfo.idx}
					required_tickets={required_tickets}
					refetch={handleRefetch}
					isTournament={true}
					clearAndRescan={clearAndRescan}
				/>
			}
		>
			<Style.Content>
				{/* Player Information */}
				<PlayerInfo
					nickname={userInfo.nickname || '홀덤여신'}
					name={userInfo.name || '정미애'}
					phoneNumber={userInfo.contact || '010-3714-0305'}
					playerId={userInfo.idx || '176'}
					qualification={getQualification(userInfo)}
					isVerified={true}
					avatarUrl={userInfo.profile_img || null}
				/>

				<TournamentSection
					scanData={scanData}
					refetch={handleRefetch}
					isLoading={isLoading}
				/>
			</Style.Content>
		</BottomSheet>
	)
}

export default TournamentBottomSheet
